export const IDLENESS_TIME_TO_SHOW_WARNING = 60 * 5; // 5 min
export const IDLENESS_WARNING = 120; // 2 minutes
